var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.images.length || _vm.uploadingImages.length
        ? [
            _c("div", { staticClass: "col-md-12" }, [
              _c("strong", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.images")) +
                    " (" +
                    _vm._s(_vm.images.length) +
                    ")\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 mt-2" }, [
              _c(
                "ul",
                { staticClass: "images" },
                [
                  _vm._l(_vm.uploadingImages, function(file, index) {
                    return _c("li", { key: "uploading-" + index }, [
                      _vm._m(0, true)
                    ])
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.images, function(file, index) {
                    return _c("li", { key: index }, [
                      _c("span", { staticClass: "drop-shadow" }),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: file.file_source },
                        on: {
                          click: function($event) {
                            return _vm.openImage(file.file_source)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.hasRoleDelete
                        ? _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(index, file)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash" })]
                          )
                        : _vm._e()
                    ])
                  })
                ],
                2
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.otherFiles.length || _vm.uploadingOtherFiles.length
        ? [
            _c("div", { staticClass: "col-md-12 mt-3" }, [
              _c("strong", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.files")) +
                    " (" +
                    _vm._s(_vm.otherFiles.length) +
                    ")\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 mt-2" }, [
              _c(
                "ul",
                { staticClass: "files" },
                [
                  _vm._l(_vm.uploadingOtherFiles, function(file, index) {
                    return _c(
                      "li",
                      {
                        key: "uploading-" + index,
                        staticStyle: {
                          display: "flex",
                          "justify-content": "unset",
                          "align-items": "center",
                          gap: "12px"
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-spinner spin" }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.uploading")) +
                            '\n          "' +
                            _vm._s(file.file_name) +
                            '"\n        '
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.otherFiles, function(file, index) {
                    return _c("li", { key: index }, [
                      _c(
                        "a",
                        { attrs: { href: file.file_source, target: "_blank" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(file.file_name) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.hasRoleDelete
                        ? _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(index, file)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash" })]
                          )
                        : _vm._e()
                    ])
                  })
                ],
                2
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !(_vm.images.length || _vm.uploadingImages.length) &&
      !(_vm.otherFiles.length || _vm.uploadingOtherFiles.length)
        ? [_c("div", { staticClass: "col-12" }, [_vm._v("-")])]
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreateButton && _vm.hasRoleCreate
        ? _c("div", { staticClass: "col-md-12 mt-2" }, [
            _c(
              "button",
              { staticClass: "btn btn-light btn-create upload-file" },
              [
                _vm._v(
                  "\n      + " + _vm._s(_vm.createButtonText) + "\n      "
                ),
                _c("input", {
                  ref: "inputFile",
                  attrs: { type: "file" },
                  on: { change: _vm.handleFileChange }
                })
              ]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-image" }, [
      _c("i", { staticClass: "fas fa-spinner spin" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07bc50fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07bc50fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSectionDocRefFile.vue
// module id = null
// module chunks = 